import Input from "../../Shared/Input";
import TextArea from "../../Shared/TextArea";
import Button from "../../Shared/Button";
import { CreateFaq } from "../../../api/FAQs/CreateFAQ";
import { ButtonTypes } from "../../../utils/consts";
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { queryClient } from "../../../main";

const validationSchema = Yup.object({
  question: Yup.string()
    .required("Question is required")
  ,
  answer: Yup.string()
    .required("Answer is required")
  ,
});

const AddFaq = ({ onSuccess }: { onSuccess?: () => void }) => {
    const [faqs, setFaqs] = useState([{ id: 1, question: "", answer: "", video: "" }]);
    const [isSubmitting, setIsSubmitting] = useState(false);
  
  
    const handleAddFaq = () => {
      const newFaq = { id: faqs.length + 1, question: "", answer: "", video: "" };
      setFaqs([...faqs, newFaq]);
    };
  
    const handleChange = (index: number, field: string, value: string) => {
      const updatedFaqs = faqs.map((faq, idx) => {
        if (idx === index) {
          return { ...faq, [field]: value };
        }
        return faq;
      });
      setFaqs(updatedFaqs);
    };
  
    const handleDeleteFaq = (index: number) => {
      setFaqs(faqs.filter((_, idx) => idx !== index));
    };
  
    const { mutate } = useMutation({
      mutationFn: CreateFaq,
      onSuccess: () => {
        toast.success("FAQ Added successfully");
        queryClient.invalidateQueries({ queryKey: ["faqs"] });
        setIsSubmitting(true);
        onSuccess && onSuccess();
      },
      onError: (error) => {
        toast.error("Error adding FAQ");
        console.error(error);
      },
    });
    const handleSubmit = (event: { preventDefault: () => void; }) => {
      event.preventDefault();
      if (faqs.every(faq => validationSchema.isValidSync(faq))) {
        const payload = faqs.map(({ question, answer, video }) => ({
          question,
          answer,
          video
        }));
        mutate(payload);
      } else {
        faqs.forEach((faq, index) => {
          const errors = validationSchema.validateSync(faq, { abortEarly: false });
          Object.entries(errors).forEach(([key, value]) => {
            toast.error(`${key} at position ${index + 1}: ${value}`);
          });
        });
      }
    };
  
  return (
    <>
    <div className="mb-9 flex justify-between">
      <div>
        <h1 className="font-bold text-28px mb-2.5">
          Frequently Asked Questions
        </h1>
        <p className="text-lightGray font-medium">
          Add a questions and answers for your students
        </p>
      </div>
      <Button
        onClick={handleAddFaq}
        variant="primary"
        className="!bg-[#DBF0FE] !text-[#4379EE] border-[#62BDF8] border hover:border-transparent hover:text-white hover:!bg-[#62BDF8] !h-12 w-40 px-1 text-lg font-bold"
      >
        Add FAQs
      </Button>
    </div>
    <div className="">
      <div className="border-b border-black/20 pb-10">
        <form onSubmit={handleSubmit} className="max-w-[600px] space-y-8">
          {faqs.map((faq, index) => (
            <div key={faq.id}>
              <Input
                value={faq.question}
                className="w-full"
                inputStyles="border-opacity-15"
                placeholder="Question"
                name="question"
                type="text"
                onChange={(e) => handleChange(index, 'question', e.target.value)}

              />
              <Input
                value={faq.video}
                className="w-full"
                inputStyles="border-opacity-15"
                placeholder="Video (Optional) "
                name="video"
                type="text"
                onChange={(e) => handleChange(index, 'video', e.target.value)}
              />

              <TextArea
                value={faq.answer}
                name="answer"
                placeholder="Enter Answer"
                inputStyles="!h-32"
                onChange={(e) => handleChange(index, 'answer', e.target.value)}
              />
              <div className="flex justify-end gap-3 mt-4">
                <Button
                  type={ButtonTypes.BUTTON}
                  onClick={() => handleDeleteFaq(index)}
                  className="before:!bg-primary hover:text-white !text-base !font-bold !h-9 w-20 !border-primary !border-2 text-primary"
                  variant="transparent"
                >
                  Cancel
                </Button>
              </div>

            </div>
          ))}
          <Button
            type={ButtonTypes.SUBMIT}
            variant="primary"
            className="!h-9 w-20 !text-base !font-bold ml-auto"
            disabled={isSubmitting}
          >
            Add
          </Button>

        </form>
      </div>
    </div>
  </>
)
}

export default AddFaq